// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","533":"component---src-pages-hiabram-js"}[chunkId] + "-" + {"293":"a8a118f968999d3f5d9d","533":"0bb2bc9eea2fb225689a"}[chunkId] + ".js";
};